import videojs from 'video.js';

import { Event } from '@src/types/event';

const SeekBar = videojs.getComponent('SeekBar');

class CustomSeekBar extends SeekBar {
  videoWasPlaying?: boolean; // used inside SeekBar.handleMouseUp

  handleMouseDown(evt: videojs.EventTarget.Event) {
    // trigger event first before call parent's handleMouseDown, so the seek time will be correct
    this.player_.trigger(Event.SEEKMOUSEDOWN, { originalType: evt.type });
    super.handleMouseDown(evt);
  }

  handleMouseUp(evt: videojs.EventTarget.Event) {
    if (this.player_.adsManagerPlugin?.isAdPlaying?.()) {
      this.videoWasPlaying = false; // so wont trigger player.play() on mouseup/touchend
    }
    this.player_.trigger(Event.SEEKMOUSEUP, { originalType: evt.type });
    super.handleMouseUp(evt);
  }
}

// override video.js original SeekBar
videojs.registerComponent('SeekBar', CustomSeekBar);

export default CustomSeekBar;
